import React from 'react';
import { Link } from 'react-router-dom';

const HerbalExtraction = () => {
  return (
    <div>
      <div className="bg-gray-100 py-4">
        <div className="container mx-auto px-4">
          <div className="text-sm text-gray-600">
            <Link to="/" className="hover:text-accent">Home</Link> / 
            <Link to="/services" className="hover:text-accent"> Services</Link> / 
            <span className="text-gray-900"> Herbal Extraction Equipment</span>
          </div>
        </div>
      </div>

      <section className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">Herbal Extraction Equipment</h1>
          <p className="text-xl text-gray-300">Specialized Equipment and Solutions</p>
        </div>
      </section>

      <section className="py-12 bg-white">
        <div className="container mx-auto px-4 max-w-5xl">
          <p className="text-lg text-gray-700 mb-8">
            Comprehensive range of specialized equipment designed to meet your process requirements.
          </p>
        </div>
      </section>

      <section className="py-16 bg-black text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">Need More Information?</h2>
          <Link to="/contact" className="btn-primary px-8 py-3 rounded-lg font-semibold inline-block">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HerbalExtraction;
